import { get } from './request'

export async function fetchSettings() {
  const settings = await get<any>('/settings')
  return settings
}
